import { FC } from "react";

import { useGetEmployeeConfigurationQuery } from "web/features/employee/employeeApiSlice";

import OrderDetailsLegalAccordions from "./orderDetailsLegalAccordions";

const OrderDetailsAnixeTourismLegals: FC = () => {
  const { data: employeeConfig } = useGetEmployeeConfigurationQuery();

  return (
    <OrderDetailsLegalAccordions
      withdrawalContent={employeeConfig?.tourismWithdrawal}
      tourismVariant
    />
  );
};

export default OrderDetailsAnixeTourismLegals;
